// Lightweight per-route SEO (no external dependency). Updates document title,
// meta description and canonical on navigation.
const SITE = "Grupo Ritual";
const BASE = "https://gruporitual.com";

export const SEO_MAP = {
  "/": {
    title: `${SITE} · Café de Especialidad y Gastronomía en Valencia`,
    description: "Grupo Ritual — restaurantes, brunch y café de especialidad de origen propio en Valencia. Locales en Valterna, Llíria y Rocafort.",
  },
  "/carta": {
    title: `Carta · ${SITE}`,
    description: "Descubre nuestra carta: desayunos, brunch, almuerzos, principales, postres y café de especialidad en Valencia.",
  },
  "/menus-para-grupos": {
    title: `Menús para Grupos en Valencia · ${SITE}`,
    description: "Menús cerrados para grupos en Valencia: comidas de empresa, celebraciones, cumpleaños y reuniones. Consulta nuestros menús y reserva.",
  },
  "/tienda": {
    title: `Tienda · Café de Especialidad | ${SITE}`,
    description: "Compra café de origen propio, tarjetas regalo y experiencias. Envíos rápidos y café recién tostado de Grupo Ritual.",
  },
  "/reservas": {
    title: `Reservas · ${SITE}`,
    description: "Reserva tu mesa en Ritual Valterna, Llíria o Rocafort. Reserva online en unos segundos.",
  },
  "/locales": {
    title: `Locales · ${SITE}`,
    description: "Nuestros locales en Valencia: Valterna, Llíria y Rocafort. Horarios, direcciones y cómo llegar.",
  },
  "/naguara": {
    title: `NAGUARÀ Cafés · ${SITE}`,
    description: "NAGUARÀ Cafés, café de especialidad de origen propio cultivado en nuestra finca de Mérida, Venezuela.",
  },
  "/historia": {
    title: `Nuestra Historia · ${SITE}`,
    description: "De vender café por la ventana en pandemia a varios locales llenos de vida. Conoce la historia de Grupo Ritual.",
  },
  "/finca": {
    title: `La Finca · ${SITE}`,
    description: "Nuestra plantación en Mérida, Venezuela, a 1800 m de altitud cultivando café de excelencia 100% arábica.",
  },
  "/gracias": {
    title: `Gracias por tu pedido · ${SITE}`,
    description: "Gracias por tu compra en Grupo Ritual.",
  },
  "/tarjeta": {
    title: `Consulta tu tarjeta regalo · ${SITE}`,
    description: "Consulta el saldo y el historial de tu tarjeta regalo de Grupo Ritual.",
  },
};

const DEFAULT = SEO_MAP["/"];

function setMetaTag(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function removeCanonical() {
  const link = document.head.querySelector('link[rel="canonical"]');
  if (link) link.remove();
}

export function setSeo({ title, description, path, robots, canonical } = {}) {
  const t = title || DEFAULT.title;
  const d = description || DEFAULT.description;
  document.title = t;
  setMetaTag("name", "description", d);
  setMetaTag("property", "og:title", t);
  setMetaTag("property", "og:description", d);
  setMetaTag("name", "twitter:title", t);
  setMetaTag("name", "twitter:description", d);
  // Robots: pages are indexable by default; noindex only when explicitly requested (e.g. NotFound).
  // Setting it on every call also clears a stale "noindex" when navigating to a valid page.
  setMetaTag("name", "robots", robots || "index, follow");
  // Canonical: `canonical: null` removes it entirely so invalid URLs (NotFound) don't inherit
  // the home canonical. A provided `path` (re)creates it for valid pages.
  if (canonical === null) {
    removeCanonical();
  } else if (path != null) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${BASE}${path === "/" ? "/" : path}`);
  }
}
